export default __webpack_public_path__ + "static/blob-53-57e4862469015225c0090fbfd471c0b9.svg";